var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_c('h1',[_vm._v("Home View")]),_c('router-link',{attrs:{"to":"events"}},[_vm._v("Events")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }